export enum PaymentStatusType {
  PENDING = 'pending',
  NOT_PAID = 'not_paid',
  PARTIALLY_PAID = 'partially_paid',
  PAID = 'paid',
  REFUNDED = 'refunded',
  PARTIALLY_REFUNDED = 'partially_refunded',
}
